import React, { useState } from "react";

const DashboardTestimonialsEdit = ({ data, onClose, onSave }) => {
  const [name, setName] = useState(data.name || "");
  const [image, setImage] = useState(data.image || null);
  const [description, setDescription] = useState(data.description || "");
  const [status, setStatus] = useState(data.status || 1);
  const [tag, setTag] = useState(data.tag || "");
  const [rating, setRating] = useState(data.rating || 0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "image" && files?.length > 0) {
      setImage(files[0]); // Store the file directly
    }
  };

  const handleSave = async () => {
    try {
      setIsSubmitting(true);
      setError(null);
      
      const formData = new FormData();

      // First, add all existing data properties
      Object.keys(data).forEach((key) => {
        // Skip image since we'll handle it separately
        if (key !== "image") {
          formData.append(key, data[key]);
        }
      });
      
      formData.append("name", name);
      formData.append("description", description);
      formData.append("status", status);
      formData.append("tag", tag);
      formData.append("rating", rating);
      
      if (image && image !== data.image) {
        formData.append("image", image);
      }

      await onSave(formData);
    } catch (error) {
      console.error("Failed to save testimonial", error);
      setError("Failed to save: " + (error.message || "Unknown error"));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[9999]">
    <div className="w-[0vw] md:w-1/6"></div>
    <div
        className={`bg-white p-6 rounded shadow-lg w-full h-full flex flex-col overflow-auto`}
      >
        <h2 className="text-lg font-bold text-gray-800 mb-4 text-center">
          Edit Testimonial
        </h2>
        <div className="border-t border-gray-200 mb-6"></div>
        
        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
            {error}
          </div>
        )}
        
        <div className="flex flex-col space-y-8 flex-grow overflow-auto">
          <div className="flex">
            <p className="text-sm font-medium text-gray-500 w-1/3">Name</p>
            <textarea
              className="w-2/3 border rounded p-2 text-gray-800"
              rows="2"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="flex">
            <p className="text-sm font-medium text-gray-500 w-1/3">
              Description
            </p>
            <textarea
              className="w-2/3 border rounded p-2 text-gray-800"
              rows="4"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
          <div className="flex">
            <p className="text-sm font-medium text-gray-500 w-1/3">Status</p>
            <select
              className="w-2/3 border rounded p-2 text-gray-800"
              value={status}
              onChange={(e) => setStatus(Number(e.target.value))}
            >
              <option value={1}>Active</option>
              <option value={2}>Inactive</option>
            </select>
          </div>
          <div className="flex">
            <p className="text-sm font-medium text-gray-500 w-1/3">Image</p>
            <input
              type="file"
              className="w-2/3 border rounded p-2 text-gray-800"
              name="image"
              accept="image/jpeg, image/png, image/jpg, image/gif"
              onChange={handleInputChange}
            />
          </div>
          <div className="flex">
            <p className="text-sm font-medium text-gray-500 w-1/3">Tag</p>
            <input
              type="text"
              className="w-2/3 border rounded p-2 text-gray-800"
              value={tag}
              name="tag"
              onChange={(e) => setTag(e.target.value)}
            />
          </div>
          <div className="flex">
            <p className="text-sm font-medium text-gray-500 w-1/3">Rating</p>
            <input
              type="number"
              className="w-2/3 border rounded p-2 text-gray-800"
              value={rating}
              name="rating"
              min="0"
              max="5"
              step="0.1"
              onChange={(e) => setRating(parseFloat(e.target.value))}
            />
          </div>
        </div>
        <div className="mt-6 flex justify-start space-x-4">
          <button
            className="px-4 py-2 bg-gray-100 text-gray-600 rounded-lg"
            onClick={onClose}
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            className={`px-4 py-2 bg-blue-500 text-white rounded-lg ${
              isSubmitting ? 'opacity-70 cursor-not-allowed' : ''
            }`}
            onClick={handleSave}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Saving...' : 'Save Changes'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DashboardTestimonialsEdit;